import i18n from '@/plugins/i18n';
import { apiWithProject } from "./greenetworkAPI";

const END_POINT = "/devices";
const maintenanceRequestConfig = (config = {}) => ({
  ...config,
  headers: {
    ...config.headers,
    'Accept-Language': i18n.locale,
  },
});

const getMeasurements = (device_eui, since, until, len, timezone, page, rawResponse = false) => {
  const params = {};
  if (since) params.since = since;
  if (until) params.until = until;
  if (len) params.limit = len;
  if (timezone) params.timezone = timezone;
  if (page) params.page = page;
  return apiWithProject.get(
    `${END_POINT}/${device_eui}/functions/ElectricInverter/measurements`,
    { params, rawResponse }
  ).catch(error => { throw error });
};

const getAllMeasurements = async (device_eui, since, until, len, timezone) => {
  const firstPage = await getMeasurements(device_eui, since, until, len, timezone, 1, true);
  const totalPages = firstPage?.pagination?.totalPages ?? 1;
  const measurements = firstPage?.data ?? [];

  if (totalPages <= 1) {
    return measurements;
  }

  const allMeasurements = [...measurements];

  for (let page = 2; page <= totalPages; page += 1) {
    const response = await getMeasurements(device_eui, since, until, len, timezone, page, true);
    const pageData = response?.data ?? [];
    allMeasurements.push(...pageData);
  }

  return allMeasurements.sort((left, right) => {
    const leftTime = new Date(left?.timestamp ?? left?.date ?? 0).getTime();
    const rightTime = new Date(right?.timestamp ?? right?.date ?? 0).getTime();
    return leftTime - rightTime;
  });
};

const getSummaryData = (device_eui, type, start, end, timezone) => {
  const params = {};
  if (start) params.start = start;
  if (end) params.end = end;
  if (timezone) params.timezone = timezone;
  return apiWithProject.get(
    `${END_POINT}/${device_eui}/functions/ElectricInverter/measurements/summary/${type}`,
    { params }
  ).catch(error => { throw error });
};

const getMaintenanceTypes = (deviceEui) => apiWithProject.get(
  `${END_POINT}/${deviceEui}/maintenance/types`,
  maintenanceRequestConfig(),
);

const getMaintenanceHistory = (deviceEui, params) => apiWithProject.get(
  `${END_POINT}/${deviceEui}/maintenance`,
  maintenanceRequestConfig({ params }),
);

const createMaintenance = (deviceEui, maintenance) => apiWithProject.post(
  `${END_POINT}/${deviceEui}/maintenance`,
  maintenance,
  maintenanceRequestConfig(),
);

const updateMaintenance = (deviceEui, maintenanceId, maintenance) => apiWithProject.put(
  `${END_POINT}/${deviceEui}/maintenance/${maintenanceId}`,
  maintenance,
  maintenanceRequestConfig(),
);

const updateInstallationDate = (deviceEui, installationDateTime) => apiWithProject.put(
  `${END_POINT}/${deviceEui}/maintenance/installation-date`,
  { installationDateTime },
  maintenanceRequestConfig(),
);

const addMaintenancePhotos = (deviceEui, maintenanceId, photos) => {
  const formData = new FormData();
  photos.forEach((photo) => formData.append('photos', photo));

  return apiWithProject.post(
    `${END_POINT}/${deviceEui}/maintenance/${maintenanceId}/photos`,
    formData,
    maintenanceRequestConfig({ headers: { 'Content-Type': 'multipart/form-data' } }),
  );
};

const deleteMaintenancePhoto = (deviceEui, maintenanceId, photoId) => apiWithProject.delete(
  `${END_POINT}/${deviceEui}/maintenance/${maintenanceId}/photos/${photoId}`,
  maintenanceRequestConfig(),
);

const deleteMaintenance = (deviceEui, maintenanceId) => apiWithProject.delete(
  `${END_POINT}/${deviceEui}/maintenance/${maintenanceId}`,
  maintenanceRequestConfig(),
);

const PulseVolt = {
  getMeasurements,
  getAllMeasurements,
  getSummaryData,
  getMaintenanceTypes,
  getMaintenanceHistory,
  createMaintenance,
  updateMaintenance,
  updateInstallationDate,
  addMaintenancePhotos,
  deleteMaintenancePhoto,
  deleteMaintenance,
};

export default PulseVolt;
